export const getCurrentPathname = (storeState) =>
  storeState &&
  storeState.router &&
  storeState.router.location &&
  storeState.router.location.pathname;
